import script from "./EditPreferences.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPreferences.vue?vue&type=script&setup=true&lang=js"

import "./EditPreferences.vue?vue&type=style&index=0&id=d6a9f398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6a9f398"]])

export default __exports__